import { useCurrentVenueMapsByUuidQuery } from "../../hooks/venues";

export default function MapName({ mapUuid }: { mapUuid: string }) {
  const { data: mapsByUuid } = useCurrentVenueMapsByUuidQuery();

  return mapsByUuid && mapsByUuid[mapUuid]?.name;
}
